export default __webpack_public_path__ + "static/media/1509@2x.9dbfb379.png";